"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverRootUrl = exports.devServerRootUrl = exports.prodServerRootUrl = void 0;
exports.prodServerRootUrl = "comixtopia.com";
exports.devServerRootUrl = window.location.host;
exports.serverRootUrl = process.env.NODE_ENV === 'development'
    ? window.location.origin
    : "https://".concat(exports.prodServerRootUrl);
